"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledGrid = exports.StyledGridItem = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const theme_1 = require("@icr-ui/theme");
const getGap = (gap, hasDefault = false) => {
    if (!hasDefault)
        return;
    return (0, styled_components_1.css) `
    gap: ${gap};
  `;
};
const getGridTemplate = (range) => {
    if (!range)
        return;
    return (0, styled_components_1.css) `
    grid-column: ${range.start} / ${range.end};
  `;
};
const getGridTemplateColumns = (gridTemplateColumns, hasDefault = false) => {
    if (!gridTemplateColumns) {
        if (!hasDefault)
            return;
        return (0, styled_components_1.css) `
      grid-template-columns: 1fr;
    `;
    }
    return (0, styled_components_1.css) `
    grid-template-columns: ${gridTemplateColumns};
  `;
};
const getRightOffset = (padding) => {
    if (!padding)
        return;
    return (0, styled_components_1.css) `
    padding-right: ${padding};
  `;
};
exports.StyledGridItem = styled_components_1.default.div `
  display: flex;
  align-items: ${props => props.alignItems || 'flex-start'};
  justify-content: ${props => props.justifyContent || 'flex-start'};
  min-width: 0;

  & * {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
exports.StyledGrid = (0, styled_components_1.default)('div')((props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const b = theme_1.defaultTheme.gridDefaults.breakpoints;
    const defaultRowHeight = 'auto';
    return (0, styled_components_1.css) `
    display: grid;
    ${getGridTemplateColumns(props.gridTemplateColumns.xs)}
    grid-auto-rows: ${props.rowHeight ? `${props.rowHeight}px` : defaultRowHeight};
    width: 100%;
    ${getGap((_a = props === null || props === void 0 ? void 0 : props.gap) === null || _a === void 0 ? void 0 : _a.xs, true)}
    ${getRightOffset((_b = props === null || props === void 0 ? void 0 : props.wrapperOffsetRight) === null || _b === void 0 ? void 0 : _b.xs)}

    @media (min-width: ${`${b.sm + 1}px`}) {
      ${getGridTemplateColumns(props.gridTemplateColumns.sm)}
      ${getGap((_c = props === null || props === void 0 ? void 0 : props.gap) === null || _c === void 0 ? void 0 : _c.sm)}
      ${getRightOffset((_d = props === null || props === void 0 ? void 0 : props.wrapperOffsetRight) === null || _d === void 0 ? void 0 : _d.sm)}
    }

    @media (min-width: ${`${b.md + 1}px`}) {
      ${getGridTemplateColumns(props.gridTemplateColumns.md)}
      ${getGap((_e = props === null || props === void 0 ? void 0 : props.gap) === null || _e === void 0 ? void 0 : _e.md)}
      ${getRightOffset((_f = props === null || props === void 0 ? void 0 : props.wrapperOffsetRight) === null || _f === void 0 ? void 0 : _f.md)}
    }

    @media (min-width: ${`${b.lg}px`}) {
      ${getGridTemplateColumns(props.gridTemplateColumns.lg)}
      ${getGap((_g = props === null || props === void 0 ? void 0 : props.gap) === null || _g === void 0 ? void 0 : _g.lg)}
      ${getRightOffset((_h = props === null || props === void 0 ? void 0 : props.wrapperOffsetRight) === null || _h === void 0 ? void 0 : _h.lg)}
    }

    ${(_j = props.items) === null || _j === void 0 ? void 0 : _j.map((item, index) => {
        var _a, _b, _c, _d;
        return (0, styled_components_1.css) `
        ${exports.StyledGridItem}:nth-child(${index + 1}) {
          ${getGridTemplate((_a = item.range) === null || _a === void 0 ? void 0 : _a.xs)}
        }

        @media (min-width: ${`${b.sm + 1}px`}) {
          ${exports.StyledGridItem}:nth-child(${index + 1}) {
            ${getGridTemplate((_b = item.range) === null || _b === void 0 ? void 0 : _b.sm)}
          }
        }

        @media (min-width: ${`${b.md + 1}px`}) {
          ${exports.StyledGridItem}:nth-child(${index + 1}) {
            ${getGridTemplate((_c = item.range) === null || _c === void 0 ? void 0 : _c.md)}
          }
        }

        @media (min-width: ${`${b.lg}px`}) {
          ${exports.StyledGridItem}:nth-child(${index + 1}) {
            ${getGridTemplate((_d = item.range) === null || _d === void 0 ? void 0 : _d.lg)}
          }
        }
      `;
    })}
  `;
});
//# sourceMappingURL=styles.js.map